import { NgModule } from '@angular/core';
import { MatchingTermPipe } from './matching-term.pipe';

@NgModule({
    declarations: [MatchingTermPipe],
    exports: [MatchingTermPipe],
})
export class MatchingTermModule {}
